import React from 'react';
import {
  LineChartOutlined,
  AndroidOutlined,
  TeamOutlined,
  BankOutlined,
  GlobalOutlined
} from '@ant-design/icons';
const routes: IRoute[] = [
  {
    path: '/',
    component: () => import('layouts/BasicLayout'),
    routes: [
      {
        path: '/datacenter',
        name: '数据报表',
        isFirst: true,
        icon: <LineChartOutlined />,
        component: () => import('layouts/BlankLayout'),
        routes: [
          {
            path: '/datacenter/dialog',
            component: () => import('pages/datacenter/dialog'),
            name: '对话日志',
            key: 'DATACENTER_DIALOG',
            exact: true
          },
          {
            path: '/datacenter/dataview',
            component: () => import('pages/datacenter/dataview'),
            name: '数据看板',
            key: 'DATACENTER_DATAVIEW',
            exact: true
          }
        ]
      },
      {
        path: '/robot',
        name: '机器人管理',
        isFirst: true,
        icon: <AndroidOutlined />,
        component: () => import('layouts/BlankLayout'),
        routes: [
          {
            path: '/robot/list',
            component: () => import('pages/robot/list'),
            name: '机器人列表',
            key: 'ROBOT_LIST',
            exact: true
          },
          {
            path: '/robot/intention',
            component: () => import('pages/robot/intention'),
            name: '意图管理',
            key: 'ROBOT_INTENTION',
            exact: true
          },
          {
            path: '/robot/userinputs/:intention_id',
            component: () => import('pages/robot/intentionUserInputs'),
            name: '意图管理-用户话术',
            exact: true,
            showInMenu: false
          },
          {
            path: '/robot/dictionary',
            component: () => import('pages/robot/dictionary'),
            name: '词典管理',
            key: 'ROBOT_DICTIONARY',
            exact: true
          },
          {
            path: '/robot/dictionary/:dict_id/words',
            component: () => import('pages/robot/dictWords'),
            name: '词条管理',
            exact: true,
            showInMenu: false
          },
          {
            path: '/robot/substance',
            component: () => import('pages/robot/substance'),
            name: '实体变量管理',
            exact: true
          },
          {
            path: '/robot/flow/:bot_id/:flow_id',
            component: () => import('pages/robot/flowX6'),
            name: '流程图',
            exact: false,
            showInMenu: false
          },
          {
            path: '/robot/flowlist/:bot_id',
            component: () => import('pages/robot/flowList'),
            name: '机器人对话流',
            exact: false,
            showInMenu: false
          }
        ]
      },
      {
        path: '/modal',
        name: '大模型',
        // exact: true,
        icon: <GlobalOutlined />,
        component: () => import('layouts/BlankLayout'),
        routes: [
          {
            path: '/modal/list',
            name: '列表',
            showInMenu: true,
            component: () => import('pages/modal/list')
          },
          {
            path: '/modal/version/:modal_id',
            name: '版本管理',
            // exact: true,
            showInMenu: false,
            component: () => import('pages/modal/versionList')
          },
          {
            path: '/modal/config/:modal_id/:modal_version_id',
            name: '模型配置',
            // exact: true,
            showInMenu: false,
            component: () => import('pages/modal/modalConfig')
          },
          {
            path: '/modal/intentionManage',
            name: '意图管理',
            // exact: true,
            showInMenu: true,
            component: () => import('pages/modal/intentionManage')
          },
          {
            path: '/modal/tagManage',
            name: '标签库管理',
            // exact: true,
            showInMenu: true,
            component: () => import('pages/modal/tagManage')
          }
        ]
      },
      {
        path: '/industry',
        name: '行业库',
        // exact: true,
        icon: <BankOutlined />,
        component: () => import('pages/industry')
      },
      {
        path: '/authority',
        name: '权限管理',
        isFirst: true,
        icon: <TeamOutlined />,
        component: () => import('layouts/BlankLayout'),
        routes: [
          {
            path: '/authority/role',
            component: () => import('pages/authority/role'),
            key: 'AUTHORITY_ROLE',
            name: '角色管理',
            exact: true
          },
          {
            path: '/authority/user',
            component: () => import('pages/authority/user'),
            name: '账号管理',
            key: 'AUTHORITY_USER',
            exact: true
          }
        ]
      },
      {
        path: '/404',
        showInMenu: false,
        component: () => import('pages/exception/notFound')
      },
      {
        redirect: '/robot/list',
        showInMenu: false,
        component: () => import('pages/exception/notFound')
      }
    ]
  }
];
function addLazyComponent(routes: IRoute[]) {
  routes.forEach(route => {
    route.component = React.lazy(route.component);
    if (route.routes) {
      addLazyComponent(route.routes);
    }
  });
}
addLazyComponent(routes);
export default routes;
